/* ============================================================
   reel-modal.js — Shoppable UGC Reel Modal (#GhoncheOnYou).

   Ported unchanged from the static build's home-extra.js (section 8),
   split into its own file since snippets/reel-modal.liquid + the
   [data-reel-item] blocks it reads (sections/ugc.liquid) now appear on
   both the homepage and the product page — this loads globally instead
   of only on the index template, guarded by the same `if (reelModal)`
   check so it's a no-op on pages without the modal.
   ============================================================ */
(function () {
  "use strict";

  var reelModal = document.querySelector("[data-reel-modal]");
  if (!reelModal) return;

  var reelItems = [].slice.call(document.querySelectorAll("[data-reel-item]"));
  var currentReelIdx = 0;
  var isPlaying = false;
  var isMuted = true;
  var simTimer = null;

  var videoEl = reelModal.querySelector("[data-reel-video]");
  var posterBox = reelModal.querySelector("[data-reel-poster-box]");
  var posterImg = reelModal.querySelector("[data-reel-poster-img]");
  var progressBar = reelModal.querySelector("[data-reel-progress]");
  var playOverlay = reelModal.querySelector("[data-reel-play-icon]");
  var soundBtn = reelModal.querySelector("[data-reel-sound]");
  var soundOffIcon = soundBtn ? soundBtn.querySelector(".icon-sound-off") : null;
  var soundOnIcon = soundBtn ? soundBtn.querySelector(".icon-sound-on") : null;

  var authorAvatar = reelModal.querySelector("[data-reel-avatar]");
  var authorUser = reelModal.querySelector("[data-reel-user]");
  var prodThumb = reelModal.querySelector("[data-reel-prod-thumb]");
  var prodName = reelModal.querySelector("[data-reel-prod-name]");
  var prodPrice = reelModal.querySelector("[data-reel-prod-price]");
  var prodLink = reelModal.querySelector("[data-reel-prod-link]");

  function stopSimulation() {
    if (simTimer) { clearInterval(simTimer); simTimer = null; }
  }

  function startSimulation() {
    stopSimulation();
    if (posterBox) {
      posterBox.classList.remove("is-hidden");
      posterBox.classList.add("reel-modal__poster--kenburns");
    }
    var duration = 9000, step = 50, elapsed = 0;
    isPlaying = true;
    simTimer = setInterval(function () {
      if (!isPlaying) return;
      elapsed += step;
      var pct = Math.min((elapsed / duration) * 100, 100);
      if (progressBar) progressBar.style.width = pct + "%";
      if (elapsed >= duration) nextReel();
    }, step);
  }

  function loadReel(idx) {
    if (idx < 0) idx = reelItems.length - 1;
    if (idx >= reelItems.length) idx = 0;
    currentReelIdx = idx;

    var item = reelItems[idx];
    if (!item) return;
    var ds = item.dataset;

    if (authorAvatar) { authorAvatar.textContent = ds.reelAvatar || ""; authorAvatar.style.background = ds.reelAvatarBg || "#8a7a63"; }
    if (authorUser) authorUser.textContent = ds.reelUser || "";
    if (prodThumb) { prodThumb.src = ds.reelProdImg || ""; prodThumb.alt = ds.reelProdTitle || ""; }
    if (prodName) prodName.textContent = ds.reelProdTitle || "";
    if (prodPrice) prodPrice.textContent = ds.reelProdPrice || "";
    if (prodLink) prodLink.href = ds.reelProdUrl || "#";
    if (posterImg) { posterImg.src = ds.reelPoster || ""; posterImg.alt = ds.reelUser || "Customer wearing this outfit"; }

    if (progressBar) progressBar.style.width = "0%";
    stopSimulation();

    if (videoEl) {
      videoEl.pause();
      videoEl.removeAttribute("src");
      videoEl.load();
      videoEl.muted = isMuted;
      var videoSrc = ds.reelVideo || "";
      if (videoSrc) {
        videoEl.src = videoSrc;
        var playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.then(function () {
            isPlaying = true;
            if (posterBox) { posterBox.classList.add("is-hidden"); posterBox.classList.remove("reel-modal__poster--kenburns"); }
          }).catch(function () { startSimulation(); });
        } else {
          startSimulation();
        }
      } else {
        startSimulation();
      }
    } else {
      startSimulation();
    }
  }

  if (videoEl) {
    videoEl.addEventListener("timeupdate", function () {
      if (videoEl.duration && progressBar) progressBar.style.width = (videoEl.currentTime / videoEl.duration) * 100 + "%";
    });
    videoEl.addEventListener("ended", nextReel);
  }

  function togglePlay() {
    var isRealVideo = videoEl && videoEl.src && posterBox && !posterBox.classList.contains("reel-modal__poster--kenburns");
    if (isRealVideo) {
      if (videoEl.paused) { videoEl.play(); isPlaying = true; flashPlayIcon(false); }
      else { videoEl.pause(); isPlaying = false; flashPlayIcon(true); }
    } else {
      isPlaying = !isPlaying;
      flashPlayIcon(!isPlaying);
    }
  }

  function flashPlayIcon(isPaused) {
    if (!playOverlay) return;
    playOverlay.classList.toggle("is-visible", isPaused);
  }

  function toggleSound() {
    isMuted = !isMuted;
    if (videoEl) videoEl.muted = isMuted;
    if (soundOffIcon && soundOnIcon) { soundOffIcon.hidden = !isMuted; soundOnIcon.hidden = isMuted; }
  }

  function prevReel() { loadReel(currentReelIdx - 1); }
  function nextReel() { loadReel(currentReelIdx + 1); }

  function openModal(idx) {
    reelModal.hidden = false;
    void reelModal.offsetWidth;
    reelModal.classList.add("is-open");
    if (window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(true);
    loadReel(idx || 0);
  }

  function closeModal() {
    reelModal.classList.remove("is-open");
    if (window.__ghoncheLockPageScroll) window.__ghoncheLockPageScroll(false);
    stopSimulation();
    if (videoEl) { videoEl.pause(); videoEl.removeAttribute("src"); videoEl.load(); }
    setTimeout(function () {
      if (!reelModal.classList.contains("is-open")) reelModal.hidden = true;
    }, 250);
  }

  reelItems.forEach(function (item, idx) {
    var openBtn = item.querySelector("[data-reel-open]");
    if (openBtn) openBtn.addEventListener("click", function (e) { e.preventDefault(); openModal(idx); });
  });

  reelModal.querySelectorAll("[data-reel-close]").forEach(function (btn) { btn.addEventListener("click", closeModal); });

  var prevBtn = reelModal.querySelector("[data-reel-prev]");
  var nextBtn = reelModal.querySelector("[data-reel-next]");
  if (prevBtn) prevBtn.addEventListener("click", prevReel);
  if (nextBtn) nextBtn.addEventListener("click", nextReel);
  if (soundBtn) soundBtn.addEventListener("click", toggleSound);

  var viewportEl = reelModal.querySelector("[data-reel-viewport]");
  if (viewportEl) viewportEl.addEventListener("click", togglePlay);

  window.addEventListener("keydown", function (e) {
    if (reelModal.hidden || !reelModal.classList.contains("is-open")) return;
    if (e.key === "Escape") closeModal();
    else if (e.key === "ArrowLeft") prevReel();
    else if (e.key === "ArrowRight") nextReel();
    else if (e.key === " " && e.target.tagName !== "INPUT") { e.preventDefault(); togglePlay(); }
  });

  var touchStartX = 0, touchStartY = 0;
  var frameEl = reelModal.querySelector(".reel-modal__frame");
  if (frameEl) {
    frameEl.addEventListener("touchstart", function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    frameEl.addEventListener("touchend", function (e) {
      var diffX = e.changedTouches[0].screenX - touchStartX;
      var diffY = e.changedTouches[0].screenY - touchStartY;
      if (Math.abs(diffX) > 45 && Math.abs(diffX) > Math.abs(diffY)) {
        if (diffX < 0) nextReel(); else prevReel();
      } else if (diffY > 70 && Math.abs(diffY) > Math.abs(diffX)) {
        closeModal();
      }
    }, { passive: true });
  }
})();
